export const additionalInfoDialog = (i18n) => (data) => {
  const {label,value} = data
  return (
    <>
      <label className="align_self_center">{label}</label>
      {value?<p>{value}</p>:<i>{i18n.t("repeatedSentences.noData")}</i>}
    </>
  );
};
